webpackJsonp([35783957827783],{

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _simple = __webpack_require__(12);
	
	var _styleModule = __webpack_require__(237);
	
	var _styleModule2 = _interopRequireDefault(_styleModule);
	
	var _logo = __webpack_require__(314);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var elements = {
	    Top: __webpack_require__(320),
	    CenterLeft: __webpack_require__(317),
	    CenterRight: __webpack_require__(318),
	    BottomLeft: __webpack_require__(315),
	    BottomRight: __webpack_require__(316),
	    FarBack: __webpack_require__(319)
	};
	
	var SceneElement = function SceneElement(_ref) {
	    var name = _ref.name;
	    return _react2.default.createElement("img", { className: _styleModule2.default["sceneElement" + name], alt: name, src: elements[name] });
	};
	
	var Scene = function Scene() {
	    return _react2.default.createElement(
	        "div",
	        { className: _styleModule2.default.scene },
	        Object.keys(elements).sort().map(function (e) {
	            return _react2.default.createElement(SceneElement, { key: e, name: e });
	        })
	    );
	};
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _simple.Centered,
	        { className: [_styleModule2.default.body, "fillScreen flex-column"].join(" ") },
	        _react2.default.createElement(Scene, null),
	        _react2.default.createElement(
	            "div",
	            { className: [_styleModule2.default.logoWrapper, "mt-4"].join(" ") },
	            _react2.default.createElement("img", { src: _logo2.default, alt: "ethronsoft logo", className: "img-fluid" })
	        )
	    );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.da5f5161.svg";

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bottom-left-element.07eb56cd.svg";

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bottom-right-element.0f790f4f.svg";

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/center-left-element.8a54df15.svg";

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/center-right-element.d8425cfd.svg";

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/far-back-element.dfad258c.svg";

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/top-element.8c78fd0f.svg";

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"body":"src-components-complex-Splash----style-module---body---2fB04","logoWrapper":"src-components-complex-Splash----style-module---logoWrapper---3SQpP","scene":"src-components-complex-Splash----style-module---scene---2GWpM","sceneElementTop":"src-components-complex-Splash----style-module---sceneElementTop---nPrMf","hover-top":"src-components-complex-Splash----style-module---hover-top---RWAh7","sceneElementBottomLeft":"src-components-complex-Splash----style-module---sceneElementBottomLeft---3u7cY","hover-bottom":"src-components-complex-Splash----style-module---hover-bottom---OAzT2","sceneElementBottomRight":"src-components-complex-Splash----style-module---sceneElementBottomRight---2TbW3","sceneElementCenterLeft":"src-components-complex-Splash----style-module---sceneElementCenterLeft---2P0c5","hover-center":"src-components-complex-Splash----style-module---hover-center---aJwqL","sceneElementCenterRight":"src-components-complex-Splash----style-module---sceneElementCenterRight---1mtTT","sceneElementFarBack":"src-components-complex-Splash----style-module---sceneElementFarBack---3509_","hover-back":"src-components-complex-Splash----style-module---hover-back---1fe_s"};

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mobxReact = __webpack_require__(24);
	
	var _Splash = __webpack_require__(133);
	
	var _Splash2 = _interopRequireDefault(_Splash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = (_dec = (0, _mobxReact.inject)(function (stores) {
	  return {
	    nav: stores.navigation_store
	  };
	}), _dec(_class = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage(props) {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    props.nav.setActiveScreen("splash");
	    return _this;
	  }
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(_Splash2.default, null);
	  };
	
	  return IndexPage;
	}(_react2.default.Component)) || _class);
	
	
	IndexPage.wrappedComponent.propTypes = {
	  nav: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-4a7e35891f0db3ef8661.js